import { ComponentType, useContext } from "react";

import { LocalizerContext } from "@com.mgmtp.a12.utils/utils-localization-react/lib/main";
import { Button } from "@com.mgmtp.a12.widgets/widgets-core/lib/button";
import { ButtonGroup } from "@com.mgmtp.a12.widgets/widgets-core/lib/button-group";
import { Icon } from "@com.mgmtp.a12.widgets/widgets-core/lib/icon";
import { ModalNotification } from "@com.mgmtp.a12.widgets/widgets-core/lib/modal-notification";

import { RESOURCE_KEYS } from "../../localization";

// Do not use or custom reload here, because the bundle size will explode!
const reload = window.location.reload.bind(window.location);

const ERROR_RESOURCE_KEYS = RESOURCE_KEYS.application.general.error;

export const CriticalInitializationErrorNotification: ComponentType<{
	readonly fitToParent?: boolean;
}> = function CriticalInitializationErrorNotification({ fitToParent }) {
	const { localizer } = useContext(LocalizerContext);

	return (
		<ModalNotification
			variant="error"
			title={localizer({ key: ERROR_RESOURCE_KEYS.title.critical })}
			fitToParent={fitToParent}
			footer={
				<ButtonGroup alignment="right">
					<Button
						label={localizer({ key: ERROR_RESOURCE_KEYS.button.label.reload })}
						icon={<Icon>refresh</Icon>}
						primary
						onClick={reload}
					/>
				</ButtonGroup>
			}
		>
			<p>{localizer({ key: ERROR_RESOURCE_KEYS.message.initializationFailed.main })}</p>
		</ModalNotification>
	);
};
